import React, { useEffect } from 'react';
import ThreeDCarousel from './ThreeDCarousel';
import { demofile } from '../utils/paths';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getT } from '../utils/translations';

interface HeroProps {
  onEnterExperience?: () => void;
}

const HERO_FIRST_POSTER = demofile(`轮播demo/${encodeURIComponent('10261.poster.jpg')}`);

export default function Hero({ onEnterExperience }: HeroProps) {
  const { lang } = useLanguage();
  const t = getT(lang);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = HERO_FIRST_POSTER;
    link.fetchPriority = 'high';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <section className="relative w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 py-6 sm:py-8 lg:py-12 flex flex-col lg:flex-row items-center justify-between overflow-hidden">

      {/* Left Content */}
      <div className="w-full lg:w-1/2 z-10 mb-8 sm:mb-12 lg:mb-0 lg:pr-12">
        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold mb-3 sm:mb-4 tracking-tight">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#1664FF] to-[#B073FF]">
            {t.hero.teamName}
          </span>
        </h1>

        <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-6 sm:mb-10 leading-snug">
          {t.hero.tagline}
        </h2>

        {/* Feature List */}
        <div className="flex flex-col space-y-4 sm:space-y-5 mb-6 sm:mb-10 border-t border-b border-gray-100 py-5 sm:py-6">
          {t.hero.features.map((text, idx) => (
            <div key={idx} className="flex items-start">
              <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-primary flex-shrink-0 mt-0.5 mr-3" />
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed">{text}</p>
            </div>
          ))}
        </div>

        {/* (移除“立即体验”按钮：仅保留能力与轮播展示) */}
      </div>

      {/* Right Content - 3D Carousel */}
      <div className="w-full lg:w-1/2 h-[360px] sm:h-[450px] lg:h-[500px] relative flex items-center justify-center perspective-container">
        <ThreeDCarousel />
      </div>

    </section>
  );
}
